<script>
	import { onMount } from "svelte";
	import client from "src/services/client";
	import CustomCollapseCard from "src/components/CustomCollapseCard/CustomCollapseCard.svelte";
	import { convert } from "src/services/helpers";
	import {
		extractErrorMessage,
		splitCamelCaseAndCapitalize,
	} from "src/utils/misc";
	import DamageCarousel from "src/components/ReportCard/DamageCarousel.svelte";
	import { verdictOptions } from "src/utils/options";
	import { capitalize } from "lodash";
	import LoaderContainer from "src/components/Loader/LoaderContainer.svelte";
	import { errorMessage, loading } from "src/store/store";
	import ErrorMessageHandler from "src/components/ErrorMessageHandler/ErrorMessageHandler.svelte";

	export let id;
	let data = {};

	async function fetchRejectedReportById() {
		try {
			loading.set(true);
			const res = await client(
				"/v1/caseManagement/rejectedReport/" + id,
				{
					method: "GET",
					version: "Tasking",
				}
			);
			data = res.data;
			loading.set(false);
		} catch (error) {
			loading.set(false);
			extractErrorMessage(error);
		}
	}

	onMount(() => {
		fetchRejectedReportById();
	});
</script>

<LoaderContainer>
	<ErrorMessageHandler message={$errorMessage} />
	<div>
		<div class="d-flex align-items-baseline">
			<div class="mx-1">
				<h5>{data.plateNo}</h5>
			</div>
			<div class="mx-1">
				<span
					>{@html verdictOptions[
						data?.rejectedReason?.charAt(0).toLowerCase() +
							data?.rejectedReason?.slice(1)
					]}</span
				>
			</div>
		</div>
		<CustomCollapseCard
			title={convert(data.reportSubmittedAt)}
			isOpenDefault={true}
		>
			<div class="p-0">
				<div class="row">
					<div class="col">
						<div class="description">Booking Id</div>
						<div class="value">
							{data.bookingNo} ({splitCamelCaseAndCapitalize(
								data.bookingType
							)})
						</div>
					</div>
				</div>
				<hr class="divider" />
				<DamageCarousel
					data={{ images: data.images }}
					lightbox={true}
				/>
			</div>
		</CustomCollapseCard>
	</div></LoaderContainer
>
